module.exports = __webpack_public_path__ + "img/suitcase.8f7d36c0.png";